<template>
  <div class="DMaterialSwiper inner_center">
    <div class="swiper-box">
      <div
        v-swiper:mySwiper3="swiperOption3"
        v-if="banner.length"
        class="swiper swiper3"
      >
        <div class="swiper-wrapper">
          <div
            v-for="(vo) in banner"
            :key="vo.id"
            class="swiper-slide _pointer"
          >
            <img
              :src="vo.link"
              class="swiper-img">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "DMaterialSwiper",
  props:{
    banner:{
      type: Array,
      default:()=>[]
    }
  },
  data() {
    return {
      isShow: false,
      swiperOption3: {
        autoplay: {
          delay: 1000,
          speed: 500,
          disableOninteraction: true
        },
        //配置分页
        pagination: {
          el: '.swiper-pagination'//分页的dom节点
        },
        direction: "horizontal",
        slidesPerView: 5,
        // spaceBetween:20,
        initialSlide: 0, // 默认选中
        loop: true, // 在此无效？？？？？
        centeredSlides: true, //活动块居中
        slideToClickedSlide: false, // 点击切换
        lazy: true,
        observer: true,//修改swiper自己或子元素时，自动初始化swiper
        observeParents: true,//修改swiper的父元素时，自动初始化swiper
        on: {
          slideChange: () => {
            const c_swiper = document.getElementsByClassName("swiper3");
            // console.log("轮播图滚动事件 --->", c_swiper[0].swiper.activeIndex )
            // this.swiperOption3.initialSlide = c_swiper[0].swiper.activeIndex - 4
          },
        }
      },
    }
  },
  methods: {
    toggleSwiper(index) {
      console.log(index)
      if (index > this.banner.length - 1) {
        index = 0
      }
      if (index < 0) {
        index = this.banner.length - 1;
      }

      this.swiperOption3.initialSlide = index;
      console.log(this.swiperOption3.initialSlide)

      if (process.client) {
        this.mySwiper3.slideTo(index + 1, 1000);
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.DMaterialSwiper {
  position: relative;
  z-index: 20;
  //width: 1214px;
  //width: 1180px;
  //width: 1220px !important;
  //margin-left: -10px;
  //background: blue;


  .swiper-box {
    width: 100%;
    height: 334px;
    //border-radius: 100px 14px 14px 14px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;

    .swiper-slide{
      //width: 220px !important;
      //height: 286px !important;
      border-radius: 16px;
      overflow: hidden;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 334px;
      width: 242px !important;

      //width: 78%;
      //transform: scale(0.78);
      /*-webkit-transform: scale(0.8664);
      -moz-transform: scale(0.8664);
      -ms-transform: scale(0.8664);
      -o-transform: scale(0.8664);
      transform: scale(0.8664)*/

      img{
        width: 220px;
        height: 286px;
        border-radius: 16px;
        box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.12) !important;
      }

      &:last-child{
        //margin-right: 0;
      }
/*      &.ON{
        width: 254px;
        height: 334px;
      }*/

     /* img {
        width: 100%;
        height:100%;
      }*/
    }
    ::v-deep .swiper-slide-active{
      width: 254px !important;
      height: 334px !important;

      //width: 115%;
      //-webkit-transform: scale(1.2);
      //-moz-transform: scale(1.2);
      //-ms-transform: scale(1.2);
      //-o-transform: scale(1.2);
      //transform: scale(1.2);
      margin: 0 11px;
      img{
        width: 254px;
        height: 334px;
      }
    }

    .swiper-wrapper{
      display: flex;
      align-items: center;
      //margin-left: 20px !important;
    }
  }

}
</style>

<style lang="scss" scoped>
.DMaterialSwiper {

  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s
  }

  .fade-enter, .fade-leave-to {
    opacity: 0
  }
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s
}

.fade-enter, .fade-leave-to {
  opacity: 0
}


</style>
